import React from "react";
import type { FretboardPattern } from "../../lib/fingeringEngine";
import { ModoPositionConstellationIcon } from "./ModoPositionConstellationIcon";

export interface ModoPositionSelectorProps {
  fingerings: readonly FretboardPattern[];
  selectedIndices: number[];
  onToggle: (index: number) => void;
}

export const ModoPositionSelector: React.FC<ModoPositionSelectorProps> = ({
  fingerings,
  selectedIndices,
  onToggle,
}) => {
  if (fingerings.length === 0) return null;

  return (
    <div className="flex flex-row items-end gap-3 shrink-0">
      <div className="flex flex-col gap-1.5 shrink-0">
        <span className="text-[10px] font-sans uppercase tracking-widest text-white/30">
          Posición
        </span>
        <div className="flex flex-row items-end gap-3">
          {fingerings.map((f, idx) => {
            const active = selectedIndices.includes(idx);
            return (
              <button
                key={`${f.id ?? f.position}-${idx}`}
                type="button"
                onClick={() => onToggle(idx)}
                className="group flex cursor-pointer flex-col items-center gap-1.5"
                title={`Caja ${f.position} · ${f.notes.length} notas`}
              >
                <span
                  className={`text-[10px] font-sans uppercase tracking-widest transition-colors ${
                    active ? "text-white/80" : "text-white/30 group-hover:text-white/70"
                  }`}
                >
                  {f.position}
                </span>
                <ModoPositionConstellationIcon
                  notes={f.notes.map((n) => ({ string: n.string, fret: n.fret }))}
                  active={active}
                />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
